import { defineAsyncComponent } from 'vue';

export default {
    'carousel': defineAsyncComponent(() => import (/* webpackPrefetch: true */ './Components/Carousel')),
    'mapbox': defineAsyncComponent(() => import (/* webpackPrefetch: true */ './Components/Mapbox')),
    'modal': defineAsyncComponent(() => import (/* webpackPrefetch: true */ './Components/Modal')),
    'sticky-nav': defineAsyncComponent(() => import (/* webpackPrefetch: true */ './Components/StickyNav')),
    'vue-iframe': defineAsyncComponent(() => import (/* webpackPrefetch: true */ './Components/IFrames/VueIFrame')),
    'vue-image': defineAsyncComponent(() => import(/* webpackPrefetch: true */ './Components/Images/VueImage')),
    'vue-background-image': defineAsyncComponent(() => import(/* webpackPrefetch: true */ './Components/Images/VueBackgroundImage')),
};
